import './search/storiesSearch';
import './single/singleStory';

import components from './components';
import storiesService from './stories-service/storiesService';

const module = angular.module('websked.stories', [
  'websked.story',
  'websked.stories.search'
]);

const toLoad = [
  components,
  storiesService
];

toLoad.forEach(fn => fn(module));
